import React from "react";

const List = ({
  items = [],
  ordered = false,
  variant = "default",
  size = "base",
  spacing = "normal",
  withMargin = false,
  className = "",
  itemClassName = "",
}) => {
  const ListTag = ordered ? "ol" : "ul";

  // Base list styles
  const baseStyles = ordered
    ? "list-decimal list-inside"
    : "list-disc list-inside";

  // Variant styles (color variations)
  const variants = {
    default: "text-gray-700",
    light: "text-gray-600",
    primary: "text-custom-blue",
    warning: "text-yellow-900",
    dark: "text-gray-900",
  };

  // Size styles
  const sizes = {
    sm: "text-sm",
    base: "text-base",
    lg: "text-lg",
  };

  // Spacing styles
  const spacings = {
    tight: "space-y-1",
    normal: "space-y-2",
    relaxed: "space-y-3",
  };

  // Optional left margin
  const marginClass = withMargin ? "ml-4" : "";

  const listClasses = `${baseStyles} ${variants[variant]} ${sizes[size]} ${spacings[spacing]} ${marginClass} ${className}`;

  return (
    <ListTag className={listClasses}>
      {items.map((item, index) => {
        const content = typeof item === "string" ? item : item.content || item;

        // Check if content contains HTML tags
        if (typeof content === "string" && content.includes("<")) {
          return (
            <li
              key={index}
              className={itemClassName}
              dangerouslySetInnerHTML={{ __html: content }}
            />
          );
        }

        return (
          <li key={index} className={itemClassName}>
            {content}
          </li>
        );
      })}
    </ListTag>
  );
};

export default List;
